/**
 * Generated by orval v8.17.0 🍺
 * Do not edit manually.
 * Server, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CustomTimelineRequestDto,
  DocumentDto,
  DocumentUploadDto,
  HttpValidationProblemDetails,
  ProblemDetails,
  TimelineDataDto,
  TimelineGenerationRequestDto
} from '../models';

import { customInstance } from '../../../orvalCustomAxiosInstance';
import type { ErrorType } from '../../../orvalCustomAxiosInstance';




/**
 * Converts the markdown file to a customised DOCX
 */
export const getApiDocumentsIdDocx = (
    id: string,
 signal?: AbortSignal
) => {


      return customInstance<Blob>(
      {url: `/api/Documents/${id}/docx`, method: 'GET',
        responseType: 'blob', signal
    },
      );
    }




export const getGetApiDocumentsIdDocxQueryKey = (id: string,) => {
    return [
    `/api/Documents/${id}/docx`
    ] as const;
    }


export const getGetApiDocumentsIdDocxQueryOptions = <TData = Awaited<ReturnType<typeof getApiDocumentsIdDocx>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDocumentsIdDocx>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiDocumentsIdDocxQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiDocumentsIdDocx>>> = ({ signal }) => getApiDocumentsIdDocx(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiDocumentsIdDocx>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiDocumentsIdDocxQueryResult = NonNullable<Awaited<ReturnType<typeof getApiDocumentsIdDocx>>>
export type GetApiDocumentsIdDocxQueryError = ErrorType<ProblemDetails | HttpValidationProblemDetails>


export function useGetApiDocumentsIdDocx<TData = Awaited<ReturnType<typeof getApiDocumentsIdDocx>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDocumentsIdDocx>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDocumentsIdDocx>>,
          TError,
          Awaited<ReturnType<typeof getApiDocumentsIdDocx>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiDocumentsIdDocx<TData = Awaited<ReturnType<typeof getApiDocumentsIdDocx>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDocumentsIdDocx>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDocumentsIdDocx>>,
          TError,
          Awaited<ReturnType<typeof getApiDocumentsIdDocx>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiDocumentsIdDocx<TData = Awaited<ReturnType<typeof getApiDocumentsIdDocx>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDocumentsIdDocx>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiDocumentsIdDocx<TData = Awaited<ReturnType<typeof getApiDocumentsIdDocx>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDocumentsIdDocx>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiDocumentsIdDocxQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Converts the markdown file to a customised PDF
 */
export const getApiDocumentsIdPdf = (
    id: string,
 signal?: AbortSignal
) => {


      return customInstance<Blob>(
      {url: `/api/Documents/${id}/pdf`, method: 'GET',
        responseType: 'blob', signal
    },
      );
    }




export const getGetApiDocumentsIdPdfQueryKey = (id: string,) => {
    return [
    `/api/Documents/${id}/pdf`
    ] as const;
    }


export const getGetApiDocumentsIdPdfQueryOptions = <TData = Awaited<ReturnType<typeof getApiDocumentsIdPdf>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDocumentsIdPdf>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiDocumentsIdPdfQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiDocumentsIdPdf>>> = ({ signal }) => getApiDocumentsIdPdf(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiDocumentsIdPdf>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiDocumentsIdPdfQueryResult = NonNullable<Awaited<ReturnType<typeof getApiDocumentsIdPdf>>>
export type GetApiDocumentsIdPdfQueryError = ErrorType<ProblemDetails | HttpValidationProblemDetails>


export function useGetApiDocumentsIdPdf<TData = Awaited<ReturnType<typeof getApiDocumentsIdPdf>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDocumentsIdPdf>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDocumentsIdPdf>>,
          TError,
          Awaited<ReturnType<typeof getApiDocumentsIdPdf>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiDocumentsIdPdf<TData = Awaited<ReturnType<typeof getApiDocumentsIdPdf>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDocumentsIdPdf>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDocumentsIdPdf>>,
          TError,
          Awaited<ReturnType<typeof getApiDocumentsIdPdf>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiDocumentsIdPdf<TData = Awaited<ReturnType<typeof getApiDocumentsIdPdf>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDocumentsIdPdf>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiDocumentsIdPdf<TData = Awaited<ReturnType<typeof getApiDocumentsIdPdf>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDocumentsIdPdf>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiDocumentsIdPdfQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Mark an existing document from a project as deleted
 */
export const deleteApiDocumentsId = (
    id: string,
 signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/Documents/${id}`, method: 'DELETE', signal
    },
      );
    }



export const getDeleteApiDocumentsIdMutationOptions = <TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiDocumentsId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiDocumentsId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteApiDocumentsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiDocumentsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteApiDocumentsId(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiDocumentsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiDocumentsId>>>

    export type DeleteApiDocumentsIdMutationError = ErrorType<ProblemDetails | HttpValidationProblemDetails>

    export const useDeleteApiDocumentsId = <TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiDocumentsId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiDocumentsId>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteApiDocumentsIdMutationOptions(options), queryClient);
    }
    /**
 * Get a single document by ID.
 */
export const getApiDocumentsId = (
    id: string,
 signal?: AbortSignal
) => {


      return customInstance<DocumentDto>(
      {url: `/api/Documents/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetApiDocumentsIdQueryKey = (id: string,) => {
    return [
    `/api/Documents/${id}`
    ] as const;
    }


export const getGetApiDocumentsIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiDocumentsId>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDocumentsId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiDocumentsIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiDocumentsId>>> = ({ signal }) => getApiDocumentsId(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiDocumentsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiDocumentsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiDocumentsId>>>
export type GetApiDocumentsIdQueryError = ErrorType<ProblemDetails | HttpValidationProblemDetails>


export function useGetApiDocumentsId<TData = Awaited<ReturnType<typeof getApiDocumentsId>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDocumentsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDocumentsId>>,
          TError,
          Awaited<ReturnType<typeof getApiDocumentsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiDocumentsId<TData = Awaited<ReturnType<typeof getApiDocumentsId>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDocumentsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDocumentsId>>,
          TError,
          Awaited<ReturnType<typeof getApiDocumentsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiDocumentsId<TData = Awaited<ReturnType<typeof getApiDocumentsId>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDocumentsId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiDocumentsId<TData = Awaited<ReturnType<typeof getApiDocumentsId>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDocumentsId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiDocumentsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Update a document.
 */
export const putApiDocumentsId = (
    id: string,
    documentUploadDto?: DocumentUploadDto,
 signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/Documents/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: documentUploadDto, signal
    },
      );
    }



export const getPutApiDocumentsIdMutationOptions = <TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiDocumentsId>>, TError,{id: string;data?: DocumentUploadDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiDocumentsId>>, TError,{id: string;data?: DocumentUploadDto}, TContext> => {

const mutationKey = ['putApiDocumentsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiDocumentsId>>, {id: string;data?: DocumentUploadDto}> = (props) => {
          const {id,data} = props ?? {};

          return  putApiDocumentsId(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiDocumentsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiDocumentsId>>>
    export type PutApiDocumentsIdMutationBody = DocumentUploadDto | undefined
    export type PutApiDocumentsIdMutationError = ErrorType<ProblemDetails | HttpValidationProblemDetails>

    export const usePutApiDocumentsId = <TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiDocumentsId>>, TError,{id: string;data?: DocumentUploadDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiDocumentsId>>,
        TError,
        {id: string;data?: DocumentUploadDto},
        TContext
      > => {
      return useMutation(getPutApiDocumentsIdMutationOptions(options), queryClient);
    }
    /**
 * Generate a timeline from project user stories
 */
export const postApiDocumentsIdTimeline = (
    id: string,
    timelineGenerationRequestDto?: TimelineGenerationRequestDto,
 signal?: AbortSignal
) => {


      return customInstance<TimelineDataDto>(
      {url: `/api/Documents/${id}/timeline`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: timelineGenerationRequestDto, signal
    },
      );
    }



export const getPostApiDocumentsIdTimelineMutationOptions = <TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiDocumentsIdTimeline>>, TError,{id: string;data?: TimelineGenerationRequestDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiDocumentsIdTimeline>>, TError,{id: string;data?: TimelineGenerationRequestDto}, TContext> => {

const mutationKey = ['postApiDocumentsIdTimeline'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiDocumentsIdTimeline>>, {id: string;data?: TimelineGenerationRequestDto}> = (props) => {
          const {id,data} = props ?? {};

          return  postApiDocumentsIdTimeline(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiDocumentsIdTimelineMutationResult = NonNullable<Awaited<ReturnType<typeof postApiDocumentsIdTimeline>>>
    export type PostApiDocumentsIdTimelineMutationBody = TimelineGenerationRequestDto | undefined
    export type PostApiDocumentsIdTimelineMutationError = ErrorType<ProblemDetails | HttpValidationProblemDetails>

    export const usePostApiDocumentsIdTimeline = <TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiDocumentsIdTimeline>>, TError,{id: string;data?: TimelineGenerationRequestDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiDocumentsIdTimeline>>,
        TError,
        {id: string;data?: TimelineGenerationRequestDto},
        TContext
      > => {
      return useMutation(getPostApiDocumentsIdTimelineMutationOptions(options), queryClient);
    }
    /**
 * Generate a timeline from custom phases
 */
export const postApiDocumentsTimelineCustom = (
    customTimelineRequestDto?: CustomTimelineRequestDto,
 signal?: AbortSignal
) => {


      return customInstance<TimelineDataDto>(
      {url: `/api/Documents/timeline/custom`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: customTimelineRequestDto, signal
    },
      );
    }



export const getPostApiDocumentsTimelineCustomMutationOptions = <TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiDocumentsTimelineCustom>>, TError,{data?: CustomTimelineRequestDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiDocumentsTimelineCustom>>, TError,{data?: CustomTimelineRequestDto}, TContext> => {

const mutationKey = ['postApiDocumentsTimelineCustom'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiDocumentsTimelineCustom>>, {data?: CustomTimelineRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  postApiDocumentsTimelineCustom(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiDocumentsTimelineCustomMutationResult = NonNullable<Awaited<ReturnType<typeof postApiDocumentsTimelineCustom>>>
    export type PostApiDocumentsTimelineCustomMutationBody = CustomTimelineRequestDto | undefined
    export type PostApiDocumentsTimelineCustomMutationError = ErrorType<ProblemDetails | HttpValidationProblemDetails>

    export const usePostApiDocumentsTimelineCustom = <TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiDocumentsTimelineCustom>>, TError,{data?: CustomTimelineRequestDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiDocumentsTimelineCustom>>,
        TError,
        {data?: CustomTimelineRequestDto},
        TContext
      > => {
      return useMutation(getPostApiDocumentsTimelineCustomMutationOptions(options), queryClient);
    }
